module.exports = __webpack_public_path__ + "static/media/idea-bulb.4580f591.svg";